module.exports = __webpack_public_path__ + "img/second_.58fcb2e0.jpg";